import { useEffect } from "react";
import { useCotiUnlock, type AccountStateResult } from "@coti-io/coti-wallet-plugin";

export type RefreshPrivateBalancesFn = () => Promise<AccountStateResult>;

interface PrivateUnlockRefreshBridgeProps {
  register: (refresh: RefreshPrivateBalancesFn | null) => void;
}

/**
 * Exposes refreshPrivateBalances to AppProviders, which sits above
 * CotiPluginProvider and so cannot call useCotiUnlock itself.
 * Lets the privateUnlock.onUnlocked callback refetch balances once the
 * onboard modal is dismissed.
 */
const PrivateUnlockRefreshBridge = ({ register }: PrivateUnlockRefreshBridgeProps) => {
  const { refreshPrivateBalances } = useCotiUnlock();

  useEffect(() => {
    // preserveSessionOnError: a transient AES/onboarding error here must not
    // re-lock the wallet the user just unlocked.
    register(() => refreshPrivateBalances({ preserveSessionOnError: true }));
    return () => register(null);
  }, [refreshPrivateBalances, register]);

  return null;
};

export default PrivateUnlockRefreshBridge;
